const customJsonstringify = str => JSON.stringify(str).replace(/([&"'<>])/g, ( char) => {
  switch (char) {
  case '&':
      return '\u0026'
  case '<':
      return '\u003c'
  case '>': 
      return '\u003e'
  case '"':
      return '\u0022'
  case "'":
      return "\u0027"
  default:
      return char
  }
})

module.exports = function(locale, preview, sectionIds = []) {
  return `
  fragment ComponentWidthFragment on ComponentWidth {
    sys {
      id
    }
    name
    desktopComponentWidth
    smartphoneComponentWidth
    tabletComponentWidth
  }
  
  fragment CardFragment on Callout {
    sys {
      id
    }
    __typename
    name
    styles
    variant
    componentWidth {
      ... on ComponentWidth {
        ...ComponentWidthFragment
      }
    }
    image {
      __typename
      ...on ImageSet{
        ...ImageSetFragment
      }
      ...on Image{
        altText
      tooltip
      image {
        title
        url
        fileName
      }
      }
    }
    title
    subTitle
    text
    supportingText
    callToActionsCollection(limit: 2) {
      ... on CalloutCallToActionsCollection {
        items {
         
          ... on LinkButton {
            ...LinkButtonFragment
          }
          ... on ImageButton {
            ...ImageButtonFragment
          }
        }
      }
    }
  }
  
  fragment ImageFragment on Image {
    sys {
      id
    }
    name
    altText
    styles
    componentWidth {
      ... on ComponentWidth {
        ...ComponentWidthFragment
      }
    }
    image {
      url
      fileName
      contentType
    }
    tooltip
    __typename
  }
  
  fragment RichTextFragment on ContentTypeRichText {
    sys {
      id
    }
    __typename
    name
    styles
    body
    componentWidth {
      ... on ComponentWidth {
        ...ComponentWidthFragment
      }
    }
  }
  
  fragment HeadingFragment on HeadingTypes {
    sys {
      id
    }
    styles
    headingName
    componentWidth {
      ... on ComponentWidth {
        ...ComponentWidthFragment
      }
    }
    heading
    __typename
  }
  
  fragment LinkButtonFragment on LinkButton {
    __typename
    sys {
      id
    }
    name
    styles
    link
    linkText
    tooltip
    gaEventClass
    variant
    target
    referencePageCollection(limit: 1) {
      items {
        ... on Product {
          parentPage{
            slug
          }
          sys {
            id
          }
          gtin
          slug
        }
      }
    }
    componentWidth {
      ... on ComponentWidth {
        ...ComponentWidthFragment
      }
    }
  }
  
  fragment ImageButtonFragment on ImageButton {
    sys {
      id
    }
    name
    styles
    altText
    linkText
    link
    tooltip
    gaEventClass
    target
    componentWidth {
      ... on ComponentWidth {
        ...ComponentWidthFragment
      }
    }
    image {
      url
      fileName
      contentType
      title
    }
    imageMobile{
     url
      fileName
      contentType
      title
  }
    __typename
  }
  
  fragment ImageSetFragment on ImageSet {
    sys {
      id
    }
    __typename
    name
    altText
    ariaLabel
    styles
    desktopImage {
      title
      url
      fileName
    }
    tabletImage {
      title
      url
      fileName      
    }
    smartphoneImage {
      title
      url      
      fileName
    }
    componentWidth {
      ... on ComponentWidth {
        ...ComponentWidthFragment
      }
    }
  }
  fragment QuotesTextFragment on QuotesText {
    sys{
    id
    }
    styles
    name
    text
    quoteSymbolCollection(limit:2){
      items{
        __typename
      }
    } 
}
  fragment VideoFragment on Video {
    sys {
      id
    }
    __typename
    styles
    videoLink
    autoplay
    videoThumbnail {
      alt: title
      url
    }
     videoMobileThumbnail{
                 alt: title
                url
              }
    componentWidth {
      ... on ComponentWidth {
        ...ComponentWidthFragment
      }
    }
  }
  
  fragment ContentfulBannerFragment on Banner {
    sys {
      id
    }
    __typename
    styles
    variant
    name
    contentCollection(limit: 4) {
      items {
        ... on HeadingTypes {
          ...HeadingFragment
        }
        ... on ContentTypeRichText {
          ...RichTextFragment
        }
      }
    }
    relatedProductCollection(limit: 4){
      items{
        sys{
          id
        }
        productName
        productShortName
        shortDescription
        slug
        parentPage{
          slug
        }
        productCategoryType
        breadcrumbTitle
        heroImage{
          sys{id}
          title
          contentType
          fileName
          url
        }
        ratingAndReviewId 

      }

    }
    image {
      ... on ImageSet {
        ...ImageSetFragment
      }
    }
    contentPosition
    textAlign
    badgeImagesCollection(limit: 1) {
      items {
        ... on Image {
          ...ImageFragment
        }
      }
    }
    componentWidth {
      ... on ComponentWidth {
        ...ComponentWidthFragment
      }
    }
    callToActionCollection(limit: 2) {
      items {
        ... on LinkButton {
          ...LinkButtonFragment
        }
      
        ... on ImageButton {
          ...ImageButtonFragment
        }
      }
    }
  }
  fragment CarouselFragment on Carouselcontainer {
    styles
    sectionTitle
    description
    disclaimer
    bgImage {
    ...ImageSetFragment
    }
    name
    carouselPanelsCollection(limit: 10) {
      items {
          __typename
        ... on ProductCard{
            title
            category
            linkButton{
              linkText
               link
            }
            image{ 
              ...ImageSetFragment
            }
        }
          ... on ImageSet {
            ...ImageSetFragment
          }
        ... on VideoBanner{
          name
          styles
          title
          text
          targetUrl
          componentWidth {
              ... on ComponentWidth {
                ...ComponentWidthFragment
              }
            }
          desktopVideo {
            title
            url
          }
          mobileVideo {
            title
            url
          }
          imageSet{
            altText
            styles
            smartphoneImage{
              url
              title
            }
            desktopImage{
              title
              url
            }
          }
        }    
      }
    }
    componentWidth {
      ... on ComponentWidth {
        ...ComponentWidthFragment
      }
    }
  }
  
  fragment LinkContainerFragment on LinkContainer {
    componentWidth {
      ... on ComponentWidth {
        ...ComponentWidthFragment
      }
    }
    linksCollection(limit: 15) {
      items {
        ... on LinkButton {
          ...LinkButtonFragment
        }
        ... on ImageButton {
          ...ImageButtonFragment
        }
      }
    }
  }
  
 
  
  fragment ContentfulVideoCardFragment on VideoCard {
    sys {
      id
    }
    title
    text
    video {
      ... on Video {
        ...VideoFragment
      }
    }
    callToActionsCollection(limit: 1) {
      items {
       
         ... on ImageButton {
              ...ImageButtonFragment
            }
      }
    }
    styles
    componentWidth {
      ... on ComponentWidth {
        ...ComponentWidthFragment
      }
    }
  }
  
  fragment VideoBannerFragment on VideoBanner {
    sys {
      id
    }
    name
    styles
    title
    text
    targetUrl
    componentWidth {
      ... on ComponentWidth {
        ...ComponentWidthFragment
      }
    }
    desktopVideo {
      title
      url
    }
    mobileVideo {
      title
      url
    }
    imageSet{
      altText
      styles
      smartphoneImage{
        url
        title
      }
      desktopImage{
        title
        url
      }
    }
  }

  {
    sectionContainerCollection(locale: "${locale}", preview: ${preview}, limit: ${
    sectionIds.length
  }, where: {sys: {id_in: ${customJsonstringify(sectionIds)}}}) {
      items {
        sys {
          id
        }
        domId
        styles
        ariaLabel
        backgroundImage {
          url
        }
        componentWidth {
          ... on ComponentWidth {
            ...ComponentWidthFragment
          }
        }
        sectionContentCollection(limit: 10) {
          items {
            __typename
            ... on Carouselcontainer {
              ...CarouselFragment
            }
            ... on Banner {
              ...ContentfulBannerFragment
              componentWidth {
                ... on ComponentWidth {
                  ...ComponentWidthFragment
                }
              }
            }
            ...on HomeBanner{
              sys{
                id
              }
              name
              title
              text
              contentCollection(limit:4){
                items{
                  __typename
                  ...on HeadingTypes{
                    sys{id}
                    heading
                    headingName
                    styles
                  }
                  ...on ContentTypeRichText{
                    ...RichTextFragment
                  }
                }
              }
              primaryImageCollection(limit:3){
                items{
                  sys{id}
                  altText
                  styles
                  image{
                    sys{id}
                    contentType
                    url
                  }
                }
              }
          secondaryImage{
                sys{id}
                name
                image{
                  url
                  contentType
                }
                altText
                styles
              }
              linkButton{
                sys{id}
                linkText
                target
                variant
                link
                styles
              }
            }
            ...on HomepageCarousel{
              sys{id}
              name
              styles
              carouselPanelsCollection(limit:4){
                items{
                  __typename
                  ...on Callout{
                    sys{id}
                    title
                    text
                    bgColor
                    callToActionsCollection(limit:1){
                      items{
                        ...on LinkButton{
                          linkText
                          link
                        }
                      }
                    }
                    image{
                      ...on Image{
                        sys{id}
                      name
                      image{sys{id}
                      title
                      contentType
                      url}
                      }
                      ...on ImageSet{
                        ...ImageSetFragment
                      }
                    }
                    badgeImage{
                      sys{id}
                       image{sys{id}
                      title
                      contentType
                      url}
                    }
                    componentWidth{
                      sys{id}
                      name
                      desktopComponentWidth
                      smartphoneComponentWidth
                    }
                    variant
                    styles
                    link
                  }
                }
              }
            }
            ... on ContentTypeRichText {
              ...RichTextFragment
              componentWidth {
                ... on ComponentWidth {
                  ...ComponentWidthFragment
                }
              }
            }
            ... on Callout {
              ...CardFragment
              variant
            }
            ... on Image {
              ...ImageFragment
            }
            ... on VideoBanner {
              ...VideoBannerFragment
            }
            ... on ImageButton {
              ...ImageButtonFragment
            }
            ... on LinkContainer {
              ...LinkContainerFragment
            }
            ... on HeadingTypes {
              ...HeadingFragment
            }
            ... on LinkButton {
              ...LinkButtonFragment
            }
            ... on StoryCard {
            sys{
              id
            }
            name
            title
            text
            subTitle
            styles
            isLeftCard
            primaryImageCollection(limit: 1) {
              items {
                ... on Image {
                  ...ImageFragment
                }
                ... on ImageSet {
                  ...ImageSetFragment
                }
              }
            }
            relatedProductCollection(limit: 4){
              items{
                sys{
                  id
                }
                productName
                productShortName
                shortDescription
                slug
                parentPage{
                  slug
                }
                productCategoryType
                breadcrumbTitle
                heroImage{
                  sys{id}
                  title
                  contentType
                  fileName
                  url
                }
                ratingAndReviewId 

              }
 
            }
             secondaryImageCollection(limit: 1) {
              items {
                ... on Image {
                  ...ImageFragment
                }
                ... on ImageSet {
                  ...ImageSetFragment
                }
              }
            }
          }
             ... on ContentCard {
            sys{
              id
            }
            name
            title
            text
            primaryImageCollection(limit: 2) {
              items {
                name
                altText
                styles
                componentWidth {
                  ... on ComponentWidth {
                    ...ComponentWidthFragment
                  }
                }
                image {
                  description
                  url
                  size
                  fileName
                  
                }
                link
              }
            }
            styles
            linkButtonCollection(limit: 1) {
              items {
                sys {
                  id
                }
                name
                linkText
                link
                variant
                tooltip
                styles
                componentWidth {
                  ... on ComponentWidth {
                    ...ComponentWidthFragment
                  }
                }
                referencePageCollection(limit: 2) {
                  items {
                    __typename
                    ... on ContentPage {
                      sys {
                        id
                      }
                      slug
                    }
                    ... on Product {
                      sys {
                        id
                      }
                      productName
                      parentPage{
                        slug
                      }
                      slug
                      variantsCollection(limit:5){
                        items{
                          name
                          variantName
                          gtin
                        }
                      }
                      productCategoryType
                      gtin
                      ratingAndReviewId
                    }
                  }
                }
              }
            }
              referencePageCollection(limit: 5) {
              items {
                __typename
                ... on ContentPage {
                  sys {
                    id
                  }
                  name
                  slug
                  title
                  shortDescription
                  bannerImageCollection(limit: 3) {
                    items {
                      sys {
                        id
                      }
                      altText
                      smartphoneImage {
                        sys {
                          id
                        }
                        title
                        url
                      }
                      desktopImage {
                        sys {
                          id
                        }
                        title
                        url
                      }
                    }
                  }
                }
                ...on Product{
                  sys{
                    id
                  }
                  parentPage{
                    slug
                  }
                  productName
                  variantsCollection(limit:5){
                    items{
                      name
                      variantName
                      gtin
                    }
                  }
                  slug
                  productCategoryType
                  gtin
                  ratingAndReviewId
                }
              }
            }
          }
            ... on ImageSet {
              ...ImageSetFragment
            }
            ... on QuotesText {
              ...QuotesTextFragment
            } 
            ... on Video {
              ...VideoFragment
            }
            ... on VideoCard {
              ...ContentfulVideoCardFragment
            }
           ... on ProductBanners{
                name
                title
                bannerImage{
                  image{
                    desktopImage{
                      url
                    }
                    smartphoneImage{
                      url
                    }
                  }
                }
                bannerTitle
                category
                topText
                disclaimerText
                discoverNewText
                percentageText
                styles
              }
            ... on SectionContainer {
              sys {
                id
              }
              domId
              styles
              backgroundImage {
                url
              }
              componentWidth {
                ... on ComponentWidth {
                  ...ComponentWidthFragment
                }
              }
              sectionContentCollection(limit: 4) {
                items {
                  ... on HeadingTypes {
                    ...HeadingFragment
                  }
                  ... on ContentTypeRichText {
                    ...RichTextFragment
                  }
                  ...on ImageSet{
                    ...ImageSetFragment
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  
  
`;
};
